export const backgroundImages = {
  left: [
    'black-evisu-jeans.jpg',
    'blue-striped-shirt.jpg',
    'orange-white-stussy-cap.jpg',
  ],
  right: [
    'brown-calvin-klein-bag.jpg',
    'pink-navy-jordan-sneakers.jpg',
    'orange-north-face-supreme-backpack.jpg',
  ],
};
